// 自动导入components下的所有组件
const files = require.context('../components', true, /\.vue$/)
let components = {}
files.keys().forEach(file => {
  let componentName = files(file).default.name
  components[componentName] = files(file).default
})

export default components
